import { Avatar, Badge } from "antd";
import React, { useState } from "react";
import { IoIosNotifications } from "react-icons/io";
import { useNavigate } from "react-router";

import Person from "../../assets/images/staticImages/person.png";
import styles from "./Header.module.css";

// import { IMG_URL } from "../../config/Apis";
import { roles } from "../../config/roles";
import Storage from "../../utills/AsyncStorage";
// import Box from "../box/Box";
import TextComponent from "../textComponent/TextComponent";
import InputField from "../input/InputField";
import { IoPersonCircleOutline } from "react-icons/io5";
import { BsSliders } from "react-icons/bs";
import { LuSearch } from "react-icons/lu";
import { ReactComponent as LogoutIcon } from "../../assets/images/sidebarIcons/LogoutIcon.svg";
import { ReactComponent as LogoImage } from "../../assets/images/staticImages/logo.png";
import { useDispatch } from "react-redux";
import { isLogin } from "../../Store/Actions/AuthAction";

const CompHeader = ({
  onBackClick,
  title,
  collapsed,
  isProfile,
  mainHeader,
}) => {
  const role = localStorage.getItem("@role");
  const [search, setSearch] = useState("");
  // const role = Storage.getERole("@role");
  const dispatch = useDispatch();

  const navigation = useNavigate();
  const logout = () => {
    dispatch(isLogin(false));
    localStorage.clear();
  };
  // const { state } = useLocation();
  // const channel = useRef(null);
  // const user = useSelector((state) => state.AuthReducer.user);
  // const notifiCounter = useSelector(
  //   (state) => state?.NotificationReducer?.unReadNotification
  // );

  // const dispatch = useDispatch();

  // // const userData = useSelector((state) => state.AuthReducer.user);

  // useEffect(() => {
  //   const initiateUnreadNotif = () => {
  //     let pusher = new Pusher("ac81b678f2fe61e8c6eb", { cluster: "mt1" });
  //     channel.current = pusher.subscribe(user.id.toString());
  //     channel.current.bind("App\\Events\\UnreadNotificationsCount", (data) => {
  //       // console.log("Counter notifi", data);
  //       dispatch(setNotificationCount(data?.notifications_count));
  //     });
  //     dispatch(NotificationMiddleware.getNotificationCount());
  //   };
  //   initiateUnreadNotif();

  //   return () => {
  //     if (channel?.current) {
  //       channel?.current?.unsubscribe();
  //     }
  //   };
  // }, []);

  return (
    <div className={`${styles.mainHeaderDiv} ${mainHeader}`}>
      <div className={styles.logoDiv}>
        <img
          src={require("../../assets/images/logo.png")}
          className={styles.logoImage}
        />
      </div>
      <div className={styles.iconsDiv}>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => navigation("/notifications")}
        >
          <Badge color="var(--para-text)">
            <img
              src={require("../../assets/images/notificationBell.png")}
              className={styles.notificationIcon}
            />
          </Badge>
        </div>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => logout()}
          title="Logout"
        >
          <LogoutIcon className={styles.logoutIcon} />
        </div>
      </div>
    </div>
  );
};

export default CompHeader;
